export default __webpack_public_path__ + "static/media/map.6948033a.png";